import { render } from "./WhatArea.vue?vue&type=template&id=00d643bc"
import script from "./WhatArea.vue?vue&type=script&lang=js"
export * from "./WhatArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__